import React, { useContext } from 'react';
import { useEffect } from 'react';
import { ToolbarContext } from '../../contexts/toolbar-context';
import {Accordion, AccordionDetails, AccordionSummary, TextField} from "@mui/material";
import WaitSpinner from "../../components/wait-spinner";
import {Subletter} from "../../generated/graphql";

function LandlordForm({diaForm,waiting}) {
    const {errors,handleSubmit,onChange,isDirty,status} = diaForm;
    const values:Subletter = diaForm.values;
    const id = values?.id;
    const isNew = id === 'new';
    const baseUrl = '/database/landlords/';
    const toolbarContext = useContext(ToolbarContext);
    const field = {
        onChange: onChange,
    };
    useEffect(() => {
        const buttons = [{
            type: 'button',
            icon: 'save',
            tooltip: 'Save',
            callback: handleSubmit,
            label: 'Save',
            disabled: !isDirty
        }];
        toolbarContext.setSecondary(
            {
                primaryUrl:baseUrl,
                title: (!isNew ? values.name : 'New Landlord'),
                secondary: buttons,
                secondaryUrl: id
            });
    }, [isDirty, id, status]);
    return (
        <Accordion defaultExpanded={true}>
            {waiting && <WaitSpinner variant="overlay"/>}
            <AccordionSummary>Landlord</AccordionSummary>
            <AccordionDetails className="grid12">
                <TextField label="Contact Name" name="contact_name" {...field} value={values?.contact_name} error={!!errors?.contact_name}/>
                <TextField label="Company" name="company" {...field} value={values?.company} error={!!errors?.company}/>
                <TextField label="Address 1" name="address_1" {...field} value={values?.address_1} error={!!errors?.address_1}/>
                <TextField label="Address 2" name="address_2" {...field} value={values?.address_2} error={!!errors?.address_2} />
                <TextField label="City" name="city" {...field} value={values?.city} error={!!errors?.city}/>
                <TextField label="Postcode" name="postcode" {...field} value={values?.postcode} error={!!errors?.postcode} />
                <TextField label="Email" type="email" name="email" {...field} value={values?.email} error={!!errors?.email}/>
                <TextField label="Email (Alt)" name="email_2" {...field} value={values?.email_2} error={!!errors?.email_2} />
                <TextField label="Telephone" name="telephone_1" {...field} value={values?.telephone_1} error={!!errors?.telephone_1} />
                <TextField label="Telephone Alt" name="telephone_2" {...field} value={values?.telephone_2} error={!!errors?.telephone_2}/>
            </AccordionDetails>
        </Accordion>
    );
}

export default LandlordForm;
